import {lazy} from 'react';

export const ActivateExcludeAssortmentABTest = lazy(() =>
  import('./ActivateExcludedAssortmentABTest.eager').then(mod => ({
    default: mod.ActivateExcludedAssortmentABTestEager,
  })),
);
